import docFio from '../assets/doc_fio.png';
import docReadySign from '../assets/doc_ready_sign.png';
import docSign from '../assets/doc_sign.png';
import entryPoing from '../assets/entry_point.png';
import gosUslugi from '../assets/gos_uslugi.png';
import offerPng from '../assets/offer.png';

export const tenantContent = {
  first: [
    {
      img: offerPng,
      title: '1. Предлагаете собственнику подписаться онлайн',
      text: 'Некоторые объявления уже помечены специальным значком. Если значка нет — можно рассказать о процессе, поделившись этой страницей.',
    },
    {
      img: docFio,
      title: '2. Собственник создаёт договор на Госуслугах и делится с вами QR-кодом',
      text: 'Переходите по нему и вносите свои данные',
    },
  ],
  last: [
    {
      img: docReadySign,
      title: '3. Подписываете договор через Госключ',
      text: 'Это приложение семейства Госуслуг — установка полностью безопасна',
    },
    {
      img: docSign,
      title: '4. Переезжайте в новый дом',
      text: 'Копия подписанного договора хранится в вашем личном кабинете на Госуслугах',
    },
  ],
};

export const homeownerContent = {
  first: [
    {
      img: offerPng,
      title: '1. Отмечаете объявление значком \n' + '«Онлайн-договор»',
      text: 'Функция работает и без значка, но с ним объявление будет заметнее: Объявление → Договор аренды онлайн → Значок «Онлайн-договор»',
    },
    {
      img: entryPoing,
      title: '2. Переходите из объявления на Госуслуги',
      text: 'Объявление → Подписать договор онлайн',
    },
  ],
  last: [
    {
      img: gosUslugi,
      title: '3. Заполняете онлайн-договор',
      text: 'И получаете QR-код — его нужно переслать арендатору, чтобы он ввёл свои данные и поставил подпись',
    },
    {
      img: docReadySign,
      title: '4. Подписываете договор через Госключ',
      text: 'Это приложение семейства Госуслуг — установка полностью безопасна',
    },
    {
      img: docSign,
      title: '5. Спокойно сдаёте жильё',
      text: 'Копия подписанного договора хранится в вашем личном кабинете на Госуслугах',
    },
  ],
};

export const agentContent = {
  first: [
    {
      img: offerPng,
      title: '1. Отмечаете объявление значком «Онлайн-договор»',
      text: 'Функция работает и без значка, но с ним объявление будет заметнее: Объявление → Договор аренды онлайн → Значок «Онлайн-договор»',
    },
    {
      img: entryPoing,
      title: '2. Передаёте собственнику QR-код для перехода на Госуслуги',
      text: 'Сформируем его в настройках: Объявление → Подписать договор онлайн',
    },
  ],
  last: [
    {
      img: gosUslugi,
      title: '3. Собственник заполняет договор',
      text: 'И получает QR-код — его нужно передать арендатору, чтобы он ввёл свои данные и поставил подпись',
    },
    {
      img: docReadySign,
      title: '4. Участники подписывают договор через Госключ',
      text: 'Это приложение семейства Госуслуг — установка полностью безопасна',
    },
    {
      img: docSign,
      title: '5. Завершаете сделку',
      text: 'Копия подписанного договора хранится в личных кабинетах на Госуслугах — и у собственника, и у арендатора',
    },
  ],
};
